import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
import { snakeCase } from "lodash";

import FilterListRoundedIcon from "@material-ui/icons/FilterListRounded";
import ImportExportRoundedIcon from "@material-ui/icons/ImportExportRounded";
import ArrowUpwardRoundedIcon from "@material-ui/icons/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@material-ui/icons/ArrowDownwardRounded";

import { HeadingMenu } from "types";
import { color } from "style/constants";
import { IconButton } from "@material-ui/core";

interface ActionProps {
  callback(op: string, args: string[]): void;
  menuData: HeadingMenu;
}

interface ActionButtonProps {
  callback(e: any): void;
  children: JSX.Element;
  text: string;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  callback,
  children,
  text
}: ActionButtonProps) => (
  <Tooltip title={text}>
    <IconButton onClick={callback} disableRipple size="small">
      {children}
    </IconButton>
  </Tooltip>
);

export const Filter: React.FC<ActionProps> = ({
  callback,
  menuData: { dbColumn, filter, filtered }
}: ActionProps) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = (e: any): void => setAnchorEl(e.currentTarget);
  const closeMenu = (): void => setAnchorEl(null);

  const handleSelect = (value: string): void => {
    closeMenu();
    callback("filter", [dbColumn, value]);
  };

  return (
    <>
      <ActionButton callback={openMenu} text="Filter">
        <FilterListRoundedIcon htmlColor={filtered ? color.BLUE : color.DARKGRAY} />
      </ActionButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        <MenuItem key={"filter-off"} onClick={() => handleSelect("")}>
          View All
        </MenuItem>
        {filter &&
          filter.map((item, index) => (
            <MenuItem key={`filter-${index}`} onClick={() => handleSelect(snakeCase(item))}>
              {item}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export const Sort: React.FC<ActionProps> = ({
  callback,
  menuData: { dbColumn, ordered }
}: ActionProps) => {
  const handleClick = (): void => {
    const order = ordered === null ? "asc" : ordered === "asc" ? "desc" : "";
    callback("sort", [dbColumn, order]);
  };

  return (
    <ActionButton callback={handleClick} text="Sort">
      {ordered === "asc" ? (
        <ArrowDownwardRoundedIcon htmlColor={color.BLUE} />
      ) : ordered === "desc" ? (
        <ArrowUpwardRoundedIcon htmlColor={color.BLUE} />
      ) : (
        <ImportExportRoundedIcon htmlColor={color.DARKGRAY} />
      )}
    </ActionButton>
  );
};
